import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Grid } from '@material-ui/core';
import Barcode from 'react-barcode';
import CodeInfo from './CodeInfo';
import { useCodeStyles } from './styles';

const CardCode = ({ ...props }) => {
  const { code, password, barcode, barcodeNumber, onShare } = props;
  const classes = useCodeStyles();

  return (
    <Paper elevation={0} className={classes.container}>
      <Grid
        container
        direction="column"
        alignItems="center"
        justify="center"
        spacing={2}
      >
        {barcode && (
          <Barcode value={barcodeNumber} width={1.35} fontSize={16} />
        )}
        {!barcode && (
          <React.Fragment>
            <CodeInfo title="Código canje:" info={code} onShare={onShare} />
            {password && (
              <CodeInfo title="Clave:" info={password} onShare={onShare} />
            )}
          </React.Fragment>
        )}
      </Grid>
    </Paper>
  );
};

CardCode.propTypes = {
  code: PropTypes.string,
  password: PropTypes.string,
  barcode: PropTypes.bool,
  barcodeNumber: PropTypes.string,
  onShare: PropTypes.func,
};

export default CardCode;
